import type { Props as ReactModalProps } from 'react-modal';
import ReactModal from 'react-modal';

import styles from './legacy-modal.component.module.scss';

type Props = {
  isOpen?: boolean;
  onClose?: ReactModalProps['onRequestClose'];
} & Omit<ReactModalProps, 'onRequestClose' | 'isOpen'>;

/**
 * @deprecated Use `@findy-code/yuffie/ui` instead.
 */
export const LegacyModal = ({
  isOpen = true,
  shouldCloseOnOverlayClick = true,
  children,
  onClose,
  // TODO: デスクトップサイズでのみ適用されている align-items: center; がモバイルサイズでも適用され次第削除する
  className: overlayClassNameOverride,
  ...rest
}: Props) => {
  return (
    <ReactModal
      ariaHideApp={false}
      className={styles.modalStyle}
      isOpen={isOpen}
      overlayClassName={overlayClassNameOverride ?? styles.overlayStyle}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onClose}
      {...rest}
    >
      {children}
    </ReactModal>
  );
};
